import styles from './UploadBox.module.css';
import type { FC } from 'react';
import type { UploadBoxProps } from './UploadBox.types';
import { Flex, Text, Loading } from '@/_components';
import { LIMIT_FILE_UPLOAD_MAX_FILES } from '@/_constants/limits';
import { getClasses } from '@/_utils/classnames';
// @ts-ignore
import { useDropzone } from 'react-dropzone';

export const UploadBox: FC<UploadBoxProps> = ({
  isDisabled,
  isLoading,
  isOnSubtleBackground,
  allowMultiple,
  onDrop,
  accept,
  description,
  maxSizeText,
}) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    disabled: isDisabled,
    onDrop,
    maxFiles: allowMultiple ? LIMIT_FILE_UPLOAD_MAX_FILES : 1,
    accept: accept
      ? accept.split(',').reduce(
          (acc, type) => {
            acc[type] = [];
            return acc;
          },
          {} as Record<string, string[]>,
        )
      : undefined,
  });

  const uploadBoxClasses: string = getClasses(styles.uploadBox, {
    [styles.uploadBoxLoading]: isLoading,
    [styles.uploadBoxDisabled]: isDisabled,
    [styles.uploadBoxOnSubtleBackground]: isOnSubtleBackground,
  });

  return (
    <Flex
      className={uploadBoxClasses}
      isColumn={true}
      isCentered={true}
      {...getRootProps()}
    >
      {isLoading && <Loading size={24} />}
      <input {...getInputProps()} />
      {isDragActive ? (
        <Text type="small" textAlign="center">
          Drag &amp; Drop files here
        </Text>
      ) : (
        <Text type="small" textAlign="center">
          Drag &amp; Drop files here or <a className="text-advise">Browse</a>
        </Text>
      )}
      {description && (
        <Text type="small" textAlign="center" color="secondary">
          {description}
        </Text>
      )}
      <Text type="tiny" color="secondary">
        {maxSizeText || 'Max size 150 MB'}
      </Text>
    </Flex>
  );
};
